import { Loader } from '@casanova/casanova-common';
import { sendCustomRequest, sendRequest } from '@casanova/casanova-common/lib/utils/service';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateUserBranch } from 'store/auth/actions'; // Assuming this action exists
import { decodeToken, replaceToken } from '../../services/auth';
import { validateElement } from '../../utils/roles';
import { DYNAMIC_BRANCH_CHANGE } from '../../utils/roles/permissions';

const BranchSelector = (props) => {
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(props.userBranch);
  const [isUpdating, setIsUpdating] = useState(false); // Loader state
  const dispatch = useDispatch();

  const fetchBranches = async () => {
    const response = await sendCustomRequest('catalog/v1/branches?sort=name&&isEnabled=true', {}, undefined, 'GET');
    console.log('Branches:', response);
    if (response.success) {
      const transformedBranches = response.data._embedded.branches.map((branch) => ({
        uuid: branch.uuid,
        shortName: branch.shortName,
      }));
      setBranches(transformedBranches);
    } else {
      console.error('Error fetching branches:', response);
    }
  }

  const fetchUpdateBranch = async (branch) => {
    setIsUpdating(true); 
    const branchUuid = branches.find((b) => b.shortName === branch)?.uuid;
    const userUuid = props.userUuid;
    const response = await sendCustomRequest('user/v1/users/update-branch', {}, { newArea: branchUuid, userUuid: userUuid }, 'PUT');
    if(response.error) {
      console.error('Error updating branch:', response);
      setIsUpdating(false); 
      return;
    }

      setSelectedBranch(branch);
      replaceToken(response.data.data);
      dispatch(updateUserBranch(branchUuid)); 
      window.location.reload();
      setIsUpdating(false); 
  }

  useEffect(() => {
    fetchBranches();

  }, []);

  const handleBranchChange = async (event) => {
    const newBranch = event.target.value;

    await fetchUpdateBranch(newBranch)
  };

  const routes = window.location.pathname.split('/'); 
  const filteredRoutes = routes.filter((route) => route !== '');
  const isParentRoute = filteredRoutes.length === 1;
  const isExceptionalPath =
    (routes[1] === 'payments-and-charges' && routes[3] === 'detail') || // ? Detail
    (routes[1] === 'daily-rent-contracts' && routes[2] === 'contract-quote'); // ? New Contract

  return (
    <>
    <span> SUCURSAL </span>
      <select id='branchSelector' className="col-header-user branch font-weight-bold mt-1 mr-2 text-secondary text-left" value={selectedBranch} 
      onChange={handleBranchChange} 
      style={{ border: 'none', background: 'none', fontWeight: 'bold' }}
      defaultValue={props.userBranch}
        disabled={
          (isExceptionalPath ? !isExceptionalPath : !isParentRoute || isUpdating) 
          || !validateElement(DYNAMIC_BRANCH_CHANGE) //? Check if the user has permission to change branches
        } // Disable if not on parent route or if updating
      >
        {branches
        ?.filter((branch) => [
          'ff515133-ef70-45e0-8f7e-7659dbcb9c32', //? Chapultepec
          'f7ef995f-13c0-4b04-a3cf-0f0fe0df81e9', //? La Viga
          '84461aa3-28f4-4496-8472-0a483a14277a', //? Patriotismo
          '8349bc4b-7a41-4e10-bf04-7501d937a815', //? Tlalnepantla
          '29e168fc-86a6-43ea-b4c6-9e50a5330bb4', //? Vallejo
          '74908e93-4c32-4298-b049-565a2a243b10', //? Centenario
          'af93bb6c-be74-4136-9654-d63d35dd303c', //? Corporativo
          'c589db6b-73f7-4840-8375-89e8bfedb01b', //? Tlalpan
        ].includes(branch.uuid))
        ?.map((branch) => (
          <option key={branch.uuid} value={branch.shortName}>
            {branch.shortName}
          </option>
        )) || (
          null
        )}
      </select>
      {<Loader show={isUpdating} />} {/* Loader indicator */}
      </>
  );
};

export default BranchSelector;